const ActionTypes = {
    ADD_LOGIN_USER: "ADD_LOGIN_USER",
    LOGIN_USER: "LOGIN_USER",
    LOGOUT_USER: "LOGOUT_USER",
    ADD_TO_CART: "ADD_TO_CART",
    PRODUCT_SEARCH: "PRODUCT_SEARCH",
    USER_LOGIN_POPUP: "USER_LOGIN_POPUP"
}
export default ActionTypes;